import { cn } from '@bem-react/classname';

// @analyze-exports:disable
export const cnCheckbox = cn('Checkbox');
